import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { motion } from 'framer-motion';

const IMPORTANCE_ICONS = {
  low: '🟢',
  medium: '🟡',
  high: '🔴'
};

const formatDate = (dateString) => {
  try {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return null;
  }
};

const SortableTask = ({ id, task, onClick, isDragging, isOverlay }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const formattedDueDate = formatDate(task.dueDate);

  const taskContent = (
    <div className="task-content">
      <div className="task-header">
        <span className="task-grip">⋮⋮</span>
        <span className="task-importance">{IMPORTANCE_ICONS[task.importance || 'medium']}</span>
        <p className="task-text">{task.title}</p>
      </div>
      {formattedDueDate && (
        <div className="task-due-date">
          Due: {formattedDueDate}
        </div>
      )}
      {task.description && (
        <div className="task-description">
          {task.description.length > 100 
            ? `${task.description.substring(0, 100)}...` 
            : task.description}
        </div>
      )}
    </div>
  );

  if (isOverlay) {
    return (
      <div className="task-card dragging">
        {taskContent}
      </div>
    );
  }

  return (
    <motion.div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      onClick={onClick}
      className={`task-card ${isDragging ? 'dragging' : ''}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.9 }}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      {taskContent}
    </motion.div>
  );
};

export default SortableTask; 